import {difference, keys, map, sortBy, words, startCase,} from 'lodash'

(function () {
  'use strict'

  angular.module('clientDashboardApp.admin.userRoles', []).controller("UserRoleManagerCtrl", UserRoleManagerCtrl)

  UserRoleManagerCtrl.$inject = ['$scope', '$state', 'userService', 'userRoleService', 'pagingService', 'stringService', '$uibModal', 'updateService']
  function UserRoleManagerCtrl($scope, $state, userService, userRoleService, pagingService, stringService, $uibModal, updateService) {
    const vm = this

    $scope.userRoleState = {
      success: false,
      updating: false
    }
    vm.totalRoles = null
    vm.loadingRoles = true
    vm.pageStrings = stringService.adminStrings()
    vm.state = "DoneUpdating"
    vm.currentUser = userService.currentUser()

    userRoleService.getAllPermissions().then(resp => {
      vm.permissionsList = resp.data
    })

    vm.refreshRoles = () => {
      vm.loadingRoles = true
      userRoleService.getUserRoles().then(roleResp => {

        vm.roles = map(
          roleResp.data,
          role => ({...role,
            canEdit: userService.hasAccessToUser(vm.currentUser.userType, role.roleName, -1)}))

        vm.roles = sortBy(vm.roles, ['roleName'])
        vm.totalRoles = vm.roles.length;
        vm.rolesPaged = pagingService.createPagingData(vm.roles, 15, 'roleName')

        if (pagingService.getCurrentPage()) {
          vm.rolesPaged.currentPageNum = pagingService.getCurrentPage()
        }
        vm.loadingRoles = false
      })
    }

    vm.updatePagingState = () => pagingService.setCurrentPage(vm.rolesPaged.currentPageNum)

    vm.openEditRoleModal = role => {
      vm.pristineRoles = []
      angular.copy(vm.roles, vm.pristineRoles)
      const modalInstance = $uibModal.open({
        template: require('./userRolesModal.html'),
        scope: $scope,
        size: "lg",
        controller: ["$scope", UserRolesModalCtrl(vm.permissionsList, role)],
        controllerAs: 'vm',
        windowClass:'roleEditModal'
      })

      modalInstance.closed.then(res => {
        $scope.userRoleState.updating = false
        $scope.userRoleState.success = false
        angular.copy(vm.pristineRoles, vm.roles)
        vm.rolesPaged = pagingService.createPagingData(vm.roles, 15, 'roleName')
      })
    }

    $scope.savePermissions = role => {
      $scope.userRoleState.updating = true
      vm.updateRoles(role)
    }

    vm.updateRoles = role => {
      vm.updateErrorMsg = ''
      vm.loadingRoles = true

      userRoleService.updateUserRoles({[role.roleName]: role}).then(() => {
        const updateInfo = {
          status: "Active",
          type: "userRole",
          title: "User Role",
          destinationRole: "manage",
          notificationType: "detail",
          actions: [{action: "edit"}],
          name: role.roleName
        }
        updateService.registerSuccessfulUpdate(updateInfo)
        $state.reload()
      }, function updateError() {
        vm.updateErrorMsg = 'An error occurred while updating role: ' + vm.role.roleName + '!'
        vm.refreshRoles()
      })
    }

    vm.addNewRole = () => {
      const modalInstance = $uibModal.open({
        template: require('./newRoleModal.html'),
        size: 'sm',
        scope: $scope,
        controller: ["$scope", NewRoleModalController(vm.updateRoles, vm.roles.map(r => r.roleName))],
        controllerAs: 'vm',
      })

      modalInstance.closed.then(() => {
        $scope.userRoleState.updating = false
        $scope.userRoleState.success = false
      })
    }

    userService.currentUser().then(user => {
      vm.currentUser = user
      vm.refreshRoles()
    })

  }


  const NewRoleModalController = (roleUpdater, existingRoles) => function () {
    const vm = this;
    vm.saveNewRole = isValid => {
      vm.pendingResponse = true;
      vm.formSubmitted = true;
      if (!isValid) {
        vm.errorMsg = 'The form is missing some data!';
        return
      }
      const pieces = words(startCase(vm.roleName));
      const displayName = pieces.join(' ');
      const roleName = pieces.join('');

      const role = {
        roleName,
        displayName,
        "permissions": [
          "EditLocation"
        ],
      };
      roleUpdater(role)
    };

    vm.hasError = input => {
      if (!input || existingRoles.includes(input)) {
        return true
      } else {
        return input.$invalid && (!input.$pristine || vm.formSubmitted)
      }
    }

  }

  const UserRolesModalCtrl = (permissionDetailsList, role) => function ($scope) {
    const vm = this;
    vm.role = role;

    vm.byCategory = Object.entries(permissionDetailsList.reduce((soFar, x) => {
      return {
        ...soFar,
        [x.niceCategory]: (soFar[x.niceCategory] || []).concat([x])
      }
    }, {}));

    vm.isActive = permission => vm.role.permissions.indexOf(permission.name) > -1;
    vm.filterActive = permissions => permissions.filter(vm.isActive);
    vm.filterInactive = permissions => permissions.filter(p => !vm.isActive(p));

    vm.addPermission = permission => {
      if (permission && !permission.disabled) {
        vm.role.permissions = _.union(vm.role.permissions, [permission.name])
      }
    };

    vm.removePermission = permission => {
      if (!permission.disabled) {
        vm.role.permissions = _.without(vm.role.permissions, permission.name)
      }
    };

  }

})()
